import { cloneDeep } from 'lodash';

import type { LogicConditionResponse } from '@webapp/account/src/resources/logic/map-logic';

import type { LogicCondition } from '@webapp/common/entities/logic';
import { initialLogicCondition } from '@webapp/common/entities/logic';
import { mapSubCondition } from '@webapp/common/lib/map';
import { parseJSON } from '@webapp/common/lib/utils';
import type { LogicTransition } from '@webapp/common/resources/survey';
import { LinkParamsLogicType, LogicAction } from '@webapp/common/resources/survey';

import type { Link } from './links';

interface LinkResponse {
    NAME: string;
    ID: number;
    TITLE: string;
    HIDDEN: boolean;
    DISALLOW_REFILLING: boolean;
    PARAMS: string | null;
}

export const mapLink = ({ ID, NAME, TITLE }: LinkResponse): Link => ({
    id: ID,
    name: TITLE,
    code: NAME,
});

export const mapCondition = ({
    AFTER_QUESTION_ID,
    FINISH_TRANSITION,
    FINISH_TRANSITION_VARIANT,
    TRANSITION_ACTION,
    BOOL_FUNC,
    BREAK_TEXT,
    COMPLETE_TEXT,
    GOAL,
    ID,
    NEXT_QUESTIONS,
    NEXT_PAGES,
    NEXT_PAGE,
    NEXT_QUESTION,
    PARAMS,
    TO_SURVEY,
    TO_WEB,
    TRANSITION_TYPE,
    TYPE,
    RESPONSES_COUNT,
    LINK_PARAM_ID,
    ANSWERS_TO_HIDE,
    LINK_PARAMS_LOGIC_TYPE,
    conditions,
    COPY_URL_PARAMS,
}: LogicConditionResponse): LogicCondition => {
    const parsedParams: {
        linkParamValue?: string;
        variants?: Array<any>;
        finishTransition?: LogicTransition;
        minCount?: number;
        maxCount?: number;
    } = PARAMS ? parseJSON(PARAMS, {}) : {};
    const condition: LogicCondition = {
        ...cloneDeep(initialLogicCondition),
        linkParamsLogicType:
            LINK_PARAMS_LOGIC_TYPE === LinkParamsLogicType.NOT_EQUAL
                ? LinkParamsLogicType.NOT_EQUAL
                : LinkParamsLogicType.EQUAL,
        afterQuestionId: AFTER_QUESTION_ID,
        finishTransition: FINISH_TRANSITION,
        answersToHide: ANSWERS_TO_HIDE ? parseJSON(ANSWERS_TO_HIDE, []) : [],
        finishTransitionVariant: FINISH_TRANSITION_VARIANT,
        action:
            TRANSITION_ACTION === 'HIDE'
                ? LogicAction.HIDE
                : TRANSITION_ACTION === 'ANSWERS_HIDE'
                ? LogicAction.ANSWERS_HIDE
                : LogicAction.SHOW,
        expand: true,
        id: ID,
        respondent: TYPE,
        transition: GOAL,
        toQuestions: NEXT_QUESTIONS ? parseJSON(NEXT_QUESTIONS, []) : [],
        toPages: NEXT_PAGES ? parseJSON(NEXT_PAGES, []) : [],
        boolFunc: BOOL_FUNC,
        toWebsite: TO_WEB,
        completeText: COMPLETE_TEXT,
        transitionType: TRANSITION_TYPE,
        disqualText: BREAK_TEXT ? String(BREAK_TEXT) : '',
        toSurvey: TO_SURVEY,
        responsesCount: RESPONSES_COUNT,
        variants: parsedParams.variants || [],
        linkParamId: LINK_PARAM_ID,
        linkParamValue: parsedParams.linkParamValue,
        minCount: parsedParams.minCount,
        maxCount: parsedParams.maxCount,
        conditions: conditions?.map(mapSubCondition),
        toPage: NEXT_PAGE,
        toQuestion: NEXT_QUESTION,
        copyUrlParams: Boolean(COPY_URL_PARAMS),
    };
    return condition;
};
